export default "__VITE_ASSET__5b63b705__"